export const PROJECT_ACTIONS = {
	BACKDROP_SHOW: 'BACKDROP_SHOW',
	BACKDROP_HIDE: 'BACKDROP_HIDE',
}
